import type { PhoneValidation } from '@app/components/Phone/types';

import type { FormInstance } from 'antd';

export const phoneValidateHandler = async (
  form: FormInstance,
  phoneValidation: PhoneValidation,
  name: string = 'Phone'
) => {
  form?.validateFields();

  const { errorMessage, isValid } = phoneValidation;
  if (errorMessage) {
    return form?.setFields([{ name, errors: [errorMessage] }]);
  }

  if (!isValid) {
    return form?.setFields([{ name, errors: ['Обязательное поле'] }]);
  }

  form?.setFields([{ name, errors: [] }]);
};
